import React from 'react';
import moment from 'moment';
import 'moment/locale/es';

export const PagosHistorial = ({list, total, loading, costoPaquete, refresh}) => {

    return (
        <div className="top-products">
        <div className="card-body">
            <h5 className="card-title">
                Historial de pagos
                <span 
                    role="button" 
                    className={`float-right h4 ${loading && 'spinner-cargar'}`}
                    onClick={refresh}
                >
                    <i className="fas fa-sync text-success "></i>
                </span>
            </h5>
            <div className="top-products-list">
                <div className="product-item mb-3">
                        <div className="row">
                            <div className="col">
                                <h3>Total:</h3>
                                <span className="product-item-status"><strong>{ new Intl.NumberFormat("en-US", {style: "currency", currency: "MXN"}).format(total) }</strong></span>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col">
                                <h3>Saldo:</h3>
                                <span className="product-item-status text-warning"><strong>{ new Intl.NumberFormat("en-US", {style: "currency", currency: "MXN"}).format(costoPaquete - total) }</strong></span>
                            </div>
                        </div>
                    </div>
                {
                    list.map((payment, pk) => (
                        <div className="product-item animate__animated animate__fadeInUp" key={pk}>
                            <h5>{payment.tipo}</h5>
                            <span>{ moment(payment.fecha_pago).format('DD [de] MMMM [de] YYYY') }</span>
                            <span className="product-item-status product-item-success">{ new Intl.NumberFormat("en-US", {style: "currency", currency: "MXN"}).format(payment.cantidad) }</span>
                        </div>
                    ))
                }
            </div>
        </div>
        </div>
    )
}
